import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = ({ data }) => {
  return (
    <footer className="bg-black text-white pt-16 px-4 md:px-0 pb-6 font-mono">
      <div className="product-card-container mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
        {/* Company Logo & Description */}
        <div className="flex flex-col items-start text-left">
          <Link to="/">
            <img
              src={data.companyDetails.logoImageUrl}
              alt={data.companyDetails.name}
              className="md:max-w-[100px] max-w-20"
            />
          </Link>

          <p className="text-gray-400 text-sm mt-3 max-w-[250px] capitalize">
            {data.companyDetails.description}
          </p>
        </div>

        {/* Navigation Links */}
        <div className=" text-left">
          <h3 className="text-xl font-semibold text-white">Our Company</h3>
          <ul className="mt-3 space-y-2 text-gray-300 uppercase">
            {data.navigation.menuItems.map((item, index) => (
              <li key={index}>
                <Link to={item.link} className="hover:text-[#cc673d]">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Details & Social Links */}
        <div className="w-full text-left">
          <h3 className="text-xl font-semibold text-white">Contact Details</h3>
          <p className="text-gray-400 text-sm mt-3">
            <strong>{data.companyDetails.name}</strong>
            <br />
            {data.addressInfo.address}
            <br />
            {data.addressInfo.city}, {data.addressInfo.state} –{" "}
            {data.addressInfo.postalCode} {data.addressInfo.country}
          </p>
          <p className="text-gray-300 mt-2">
            Email:{" "}
            <a
              href={`mailto:${data.contactDetails.email}`}
              className="text-blue-400 hover:underline"
            >
              {data.contactDetails.email}
            </a>
          </p>

          {/* Social Media Links */}
          <div className="flex flex-wrap justify-start space-x-4 mt-4 text-gray-400 text-xl">
            <a
              href={data.navigation.socialMediaLinks[0].link}
              className="hover:text-[#cc673d]"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href={data.navigation.socialMediaLinks[1].link}
              className="hover:text-[#cc673d]"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href={data.navigation.socialMediaLinks[2].link}
              className="hover:text-[#cc673d]"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href={data.navigation.socialMediaLinks[3].link}
              className="hover:text-[#cc673d]"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="mt-12 text-center text-gray-500 text-sm border-t border-gray-700 pt-4">
        Copyright © {new Date().getFullYear()} {data.companyDetails.name}. All
        rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
